export default {
    dependencies: ['$element', 'bucketcookieservice', 'radio'],
    callable(ele, cookie, radio) {
        ele
            .querySelector('[data-link]')
            .addEventListener('click', handleLinkClick);
        ele
            .querySelector('[data-dismiss]')
            .addEventListener('click', handleDismissClick);
        radio('survey-dismissed').subscribe(removeSurveyBox);

        function handleLinkClick() {
            cookie.set('clickedSurvey', new Date().toISOString());
        }

        function handleDismissClick() {
            cookie.set('clickedSurvey', new Date().toISOString());
            radio('survey-dismissed').broadcast();
        }

        function removeSurveyBox() {
            if (ele) {
                ele.remove();
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/surveyThrottler.js